// extracted by mini-css-extract-plugin
export default {"errorMessageContainer":"admin-user-access-actions-modal_errorMessageContainer__oXQo-"};